import React from "react";
import {
  makeStyles,
  Card,
  CardContent,
  CardActions,
  Button,
  CardHeader,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@material-ui/core";

import { Link } from "react-router-dom";

import { useConfirm } from "material-ui-confirm";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-material-ui";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

//validation schema
let validationSchema = Yup.object().shape({
  description: Yup.string().required("Required"),
});

const ProductMetalEdit = (props) => {
  const classes = useStyles();
  const confirm = useConfirm();

  const initVals = {
    metalId: props.selectedMetal[0].MetalId,
    description: props.selectedMetal[0].Description,
    isActive: props.selectedMetal[0].IsActive,
  };

  const onSubmit = (values) => {
    confirm({ description: `The product metal will be saved to the database.` })
      .then(() => {
        //post the values to api
        fetch(process.env.REACT_APP_API_PRODUCT_METALS, {
          method: "PUT",
          body: JSON.stringify({ ...values }),
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => response.json())
          .then((data) => {
            props.setAction(props.actions.list);
            props.setRefreshMetals(true);
          })
          .catch((err) => {
            console.log(err.message);
          });
      })
      .catch(() => console.log("Update cancelled."));
  };

  return (
    <Card className={classes.padding}>
      <CardHeader title="Edit Product Metal"></CardHeader>
      <Formik
        initialValues={initVals}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ dirty, isValid, values, handleChange, handleBlur }) => {
          return (
            <Form>
              <CardContent>
                <Grid container spacing={1} justify="center">
                  <Grid item xs={12} sm={6} md={6}>
                    <Field
                      label="Metal Name"
                      variant="outlined"
                      fullWidth
                      name="description"
                      value={values.description}
                      component={TextField}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="select-outlined-label">
                        Is Active
                      </InputLabel>
                      <Select
                        labelId="select-outlined-label"
                        id="select-outlined"
                        label="Is Active"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.isActive}
                        name="isActive"
                      >
                        <MenuItem value="true">
                          <em>true</em>
                        </MenuItem>
                        <MenuItem value="false">
                          <em>false</em>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <CardActions>
                  <Button
                    component={Link}
                    variant="outlined"
                    to="/admin/shoppingoptions"
                    onClick={() => {
                      props.setAction(props.actions.list);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={!dirty || !isValid}
                    variant="contained"
                    color="primary"
                    type="Submit"
                    className={classes.button}
                  >
                    Save
                  </Button>
                </CardActions>
              </CardContent>
            </Form>
          );
        }}
      </Formik>
    </Card>
  );
};

export default ProductMetalEdit;
